import * as React from 'react';
import classnames from 'classnames';

var Fieldset = function Fieldset(_ref) {
  var title = _ref.title,
      className = _ref.className,
      children = _ref.children;
  return React.createElement("fieldset", {
    className: classnames(className, 'Fieldset')
  }, React.createElement("legend", {
    className: "Fieldset__header"
  }, React.createElement("div", {
    className: "Fieldset__title"
  }, title)), React.createElement("div", {
    className: "Fieldset__body"
  }, children));
};

Fieldset.defaultProps = {
  className: '',
  children: undefined
};
export default Fieldset;